var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("card-collapsable", {
        attrs: {
          headerClass: "cyan darken-1 white--text",
          dialogClass: "auctioneer",
          dialogProp: _vm.dialog,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "visible",
              fn: function () {
                return [
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("gavel"),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "title",
              fn: function () {
                return [_vm._v(" Estrazione casuale ")]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function () {
                return [
                  _c(
                    "div",
                    [
                      _c("si-sta-facendo-asta-per"),
                      _vm._v(" "),
                      _c("div", { staticClass: "chooser_random" }, [
                        _c(
                          "div",
                          { staticClass: "random-options text-center" },
                          [
                            _vm.classic
                              ? _c(
                                  "div",
                                  { staticClass: "cal-ruoli px-4 pt-4" },
                                  _vm._l(
                                    _vm.ruoli_da_chiamare,
                                    function (ruolo_id) {
                                      var _obj
                                      return _c(
                                        "v-btn",
                                        {
                                          key: ruolo_id,
                                          staticClass: "ma-2",
                                          attrs: { depressed: "", icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.estraiDaRuolo(ruolo_id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "Ruolo outline",
                                              class:
                                                ((_obj = {}),
                                                (_obj[
                                                  "Ruolo_" + ruolo_id
                                                ] = true),
                                                _obj),
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.Constants.RUOLI_NEW[
                                                    ruolo_id
                                                  ].abc
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "my-4" },
                                  _vm._l(
                                    _vm.Constants.RUOLI_MANTRA,
                                    function (mantraObj, mantra_id) {
                                      var _obj
                                      return _c(
                                        "span",
                                        {
                                          key: mantra_id,
                                          staticClass: "ruolo-mantra",
                                          class:
                                            ((_obj = {}),
                                            (_obj[
                                              "ruolo-mantra" + mantra_id
                                            ] = true),
                                            _obj),
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectRuoloMantra(
                                                mantra_id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.ruoloMantra(mantra_id))
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                            _vm._v(" "),
                            _vm.ruolo_da_chiamare ==
                            _vm.Constants.RUOLO_DA_CHIAMARE.QUALUNQUE
                              ? _c(
                                  "div",
                                  { staticClass: "pb-4" },
                                  [
                                    _c("div", { staticClass: "pb-2" }, [
                                      _vm._v("oppure"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "cyan white--text",
                                        attrs: { depressed: "", rounded: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.estraiDaRuolo(0)
                                          },
                                        },
                                      },
                                      [_vm._v("Ruolo a caso\n              ")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center pb-2 px-2" }, [
                        _vm._v(
                          "\n          (Clicca sul ruolo che vuoi estrarre)\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-right pb-2 px-2" }, [
                        _c(
                          "a",
                          {
                            staticClass: "text--text",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.manageScartati.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Gestione Scartati")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            _vm.showPasso
              ? {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-card-actions",
                        { staticClass: "justify-end" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "cyan white--text",
                              attrs: { depressed: "", rounded: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.passo()
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { small: "", left: "" } }, [
                                _vm._v("airline_stops"),
                              ]),
                              _vm._v(" Passa\n        "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }